"use client";

/**
 * Platform take when the customer pays the mistri directly (cash / UPI after service).
 * The job amount never hits Mistry Bhai — the mistri owes this fee after each completed visit.
 */
export const PLATFORM_UPI = "7790993422@ybl";
export const PLATFORM_PAYEE_NAME = "Mistry Bhai";
export const COMMISSION_RATE = 0.12;
export const COMMISSION_MIN = 30;

export function platformFeeFor(jobAmount: number) {
  const raw = Math.max(COMMISSION_MIN, Math.round(jobAmount * COMMISSION_RATE));
  return Math.max(COMMISSION_MIN, Math.round(raw / 10) * 10);
}

export function platformUpiLink(amount: number, note: string) {
  const params = new URLSearchParams({
    pa: PLATFORM_UPI,
    pn: PLATFORM_PAYEE_NAME,
    am: String(amount),
    cu: "INR",
    tn: note.slice(0, 50),
  });
  return `upi://pay?${params.toString()}`;
}
